/* global L */

'use strict';

// Constructor
var DepartmentWaitingTime = function () {
    if ($('#hospitals_map').length > 0) {

        // Grab the hospital data
        var $hospitals = JSON.parse($('#emergencywait_data').data('info'));

        // Display the hospitals
        showHospitalData($hospitals);

        // match the height of the columns
        $('#emergencywaitwrapper .inner-column').matchHeight();

        // Show the map
        showHospitalOnMap($hospitals);

        setInterval(function () {
            refreshHospitalData();
        }, 9000);

    }
};

function refreshHospitalData() {
    var previous = null;
    var current = null;
    $.ajax({
        url: "/emergency-department-waiting-times",
        type: "post"
    }).done(function ($data) {
        var $html = $.parseHTML($data);
        var $hospitals = JSON.parse($($html).find('#emergencywait_data').data('info'));
        current = $hospitals;
        if (previous && current && previous != current) {
            showHospitalData($hospitals);
        }
        previous = current;
    });
}

function showHospitalOnMap($hospitals) {

    // Create a map object
    var map = L.map('hospitals_map');

    // Array for the cordinates
    var $cordinates = [];

    // Collect all the cordinates
    $($hospitals).each(function ($index, $hospital) {
        $cordinates.push({ address: $hospital.address, location: $hospital.location, title: $hospital.title });
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);

    // Add the pins on the map
    $($cordinates).each(function ($index, $hospital) {
        var $cordinate = $hospital.location.split(",");

        var $logo = L.icon({
            iconUrl: 'https://unpkg.com/leaflet@1.3.1/dist/images/marker-icon.png',
            shadowUrl: 'https://unpkg.com/leaflet@1.3.1/dist/images/marker-shadow.png',

            iconSize: [25, 41], // size of the icon
            shadowSize: [41, 41], // size of the shadow
            iconAnchor: [25, 41], // point of the icon which will correspond to marker's location
            shadowAnchor: [24, 41], // the same for the shadow
            popupAnchor: [-12, -41] // point from which the popup should open relative to the iconAnchor
        });

        L.marker([$cordinate[0], $cordinate[1]], { icon: $logo }).addTo(map)
            .bindPopup('<strong>' + $hospital.title + '</strong><br><span>' + $hospital.address + '</span>')
            .openPopup();

    });

    // Center the map somwhere in the middle. Got the cordinates from google maps
    map.setView([-35.253032, 149.08972], 13);

    // Bind a click action to the address to zoom on the map
    $('body').on('click', '.hospital a.address', function ($event) {
        $event.preventDefault();
        var $cordinate = $(this).data('location').split(",");
        map.setView([$cordinate[0], $cordinate[1]], 16);
    });
}

function showHospitalData($hospitals) {
    // Cleanup the hospitals container
    $('.hospitals').html('');

    $($hospitals).each(function ($index, $hospital) {

        var $html = '<div class="row hospital">' +
                '                <div class="col-md-12 title uikit-header"><h3 class="uikit-header-heading">' + $hospital.title + '</h3></div>' +
                '                <div class="col-md-12 contact">' +
                '                    <a href="tel:123" class="phone"><i class="fa fa-phone"></i> ' + $hospital.phone + '</a>' +
                '                    <a data-location="' + $hospital.location + '" href="https://maps.google.com/maps?saddr=&daddr=' + $hospital.location + '" class="address"> <i class="fa fa-map-marker"></i> ' + $hospital.address + '</a>' +
                '                </div>' +
                '                   <div class="ed-wt-wrapper" >' +
                '                <div class="col-md-6 waiting_time" style="margin-top: 25px;">' +
                '                     <div class="time">' + $hospital.numPatientsWaitingTreatment + '</div>' +
                '                    <div class="note"><span>Number of Patients Waiting</span></div>' +
                '                    <div class="note">to commence Treatment</div>' +
                '                </div>' +
                '                <div class="col-md-6 waiting_time" style="margin-top: 25px;">' +
                '                    <div class="time">' + $hospital.expectedWaitingTime + '</div>' +
                '                    <div class="note"><span>Average time waited for treatment</span><span>&nbsp;(hh:mm)</span></div>' +
                '                    <div class="note">(non-critical patients treated in the last 2 hours)</div>' +
                '                </div>' +
                '                <div class="col-md-12 waiting_time" style="margin-top: 25px;   font-size: 0.7em;                ">' +
                '                   <small class="note"><span class="update">Last updated: ' + $hospital.lastUpdated + '</span>' + $hospital.lastUpdated_time + '</small>' +
                '                </div>' +

                '                </div>' +
                '            </div>';


        // Add the markup with the hospital info
        $('.hospitals').append($html);

    });
    $(".ed-wt-wrapper").find(".col-md-6").matchHeight();
}

module.exports = DepartmentWaitingTime;
